import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollTo } from 'react-scroll';
import { Element } from 'react-scroll';

const Banner = () => {
    
  return (
    <Element
      name="EnergySolutions"
      className="aura-ai-banner banner-style-1 height-640 d-flex align-items-center"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-7 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center color-body2">
                  <Link className="color-body2" to="/">Home</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  Energy
                </div>
                <h1 className="datatalent-program-title color-white title mt-4"><span className="product-banner-title">Energy</span> Industry Solutions</h1>
                <p className="product-description">Powering a Smarter, Safer, and More Resilient Energy Future with our AI powered solutions</p>
                <p className="color-body2">As the energy sector undergoes a rapid transformation toward cleaner sources and smarter infrastructure, real-time data and AI-driven insights are crucial for sustainability, reliability, and safety. M2M Tech delivers Edge AI-powered tools for predictive maintenance, anomaly detection, emissions tracking, and risk assessment to meet the demands of the modern energy ecosystem.</p>
                <div className="read-more-btn banner-btns">
                  <ScrollTo
                    className="edu-btn btn-secondary text-center"
                    to="AISolutions"
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    Learn More<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </ScrollTo>
                  <Link className="edu-btn btn-primary text-center" to="/contact-us">
                    Contact Us<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-5 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <img className="edge-ai-banner-right-image" src={`${process.env.PUBLIC_URL}/images/solutions/illustration_energy.png`} alt="M2M Edge AI device" loading="lazy" />
          </div>
        </div>
      </div>
    </Element>
  )
}

export default Banner;